module.exports = __webpack_public_path__ + "static/media/license.7316f29d.svg";